module.exports = __webpack_public_path__ + "static/media/chrnicDises.937e55b8.svg";